import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Space, Switch, Table, Upload, message } from "antd";
import { goPage } from "../../layout/pageDefinition";
import { useModel } from "../../../models";
import CustomerService from "./CustomerService"
import { filterTree } from "../../../utils/decoder"
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function ({ sForm }) {
    const [{ customerTypeDict }, { getCustomerTypeDict }] = useModel("cmDict");

    const [{ searchParam, customerList, selectedCustomer, pageInfo, selectedCustomerRowKeys, selectedTypeNode },
        { loadCustomerList, setSearchParam, setSelectedCustomer, setSelectedCustomerRowKeys, enableOrDisableCustomer }
    ] = useModel("customer");

    useEffect(() => {
        loadCustomerList({ showMsg: false, data: {} });
        setSearchParam({})
    }, [])
    const history = useHistory();
    const onAdd = () => {
        goPage(history, "6-4-2");
    }
    const onEdit = () => {
        let findCustomerList = customerList.find(item => {
            if (item.key == selectedCustomer.key) {
                return item
            }
        })
        setSelectedCustomer(findCustomerList)
        setSelectedCustomerRowKeys([findCustomerList.key]);
        goPage(history, "6-4-1");
    }

    const onExport = async () => {
        let res = {
            type: "post",
            data: {
                ...searchParam,
                "pageSize": pageInfo.pageSize,
                "pageNum": pageInfo.pageNum
            }
        }
        await CustomerService.export(res);
    }
    const onDownloadTpl = async () => {
        await CustomerService.downloadTpl();
    }
    const onPageChange = (page, pageSize) => {
        console.log(page, pageSize)
        const params = { ...searchParam };
        params.pageNum = page;
        params.pageSize = pageSize;
        console.log(params)
        if (selectedTypeNode) {
            params.customerType = selectedTypeNode.key;
        }
        loadCustomerList({ showMsg: false, data: params });
    }
    //启用、禁用
    const onDisabled = (record, checked) => {
        enableOrDisableCustomer({ showMsg: true, data: { record, checked } })
    }
    const columns = [
        {
            title: '序号',
            width: 80,
            render: (text, record, index) => `${index + 1}`,
        },
        {
            title: '客户编码',
            dataIndex: 'customerCode',
            align: 'left',
            width: 150,
        },
        {
            title: '客户名称',
            dataIndex: 'customerName',
            width: 250
        },
        {
            title: '客户类型',
            dataIndex: 'customerType',
            width: 120,
            render: (text, record, index) => <>{filterTree(customerTypeDict, text)}</>,
        },
        {
            title: '客户级别',
            dataIndex: 'customerLevel',
            width: 80
        },
        {
            title: '联系人',
            dataIndex: 'customerCorporation',
            width: 80
        },
        {
            title: '联系电话',
            dataIndex: 'customerCorporationPhone',
            width: 150
        },
        {
            title: '地址',
            dataIndex: 'customerAddress',
            width: 250,
            ellipsis: true
        },
        {
            title: '办公电话',
            dataIndex: 'customerPhone',
            width: 150
        },
        {
            title: '所属公司',
            dataIndex: 'customerAgency',
            width: 250,
            ellipsis: true
        },
        {
            title: '创建人',
            dataIndex: 'createUser',
            width: 100,
            ellipsis: true
        },
        {
            title: '登记日期',
            dataIndex: 'createTime',
            width: 120,
            render: (text, record) => `${record.createTime[0]}-${record.createTime[1]}-${record.createTime[2]}`
        },
        {
            title: '状态',
            dataIndex: 'customerStatus',
            width: 80,
            render: (text, record) => <Space size="middle" onClick={e => e.stopPropagation()}>
                <Switch
                    checked={record.customerStatus === 0}
                    onChange={checked => {
                        onDisabled(record, checked);
                    }}
                    size="small" />
            </Space>,
        },
        {
            title: '备注',
            dataIndex: 'customerDesc',
            width: 150,
            ellipsis: true
        },

    ];
    const onUploadSuccess = (retData) => {
        console.log(retData);
        let data = {
            "pageSize": 15,
            "pageNum": 1
        }
        loadCustomerList({ showMsg: false, data });
    }

    return (
        <>
            <div style={{ margin: "12px 0" }}>
                <YhAuth resCode={ResourceAuthEnum.DATA_C_AD}>
                    <Button type="primary" onClick={onAdd}>新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_C_ED}>
                    <Button className="margin-left-8" onClick={onEdit} disabled={!!!selectedCustomer}>编辑</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_C_IM}>
                    <Upload {...CustomerService.getImportCfg({ onUploadSuccess })}>
                        <Button className="margin-left-8">导入</Button>
                    </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_C_EX}>
                    <Button className="margin-left-8" onClick={onExport}>导出</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_C_DLOAD}>
                    <Button className="margin-left-8" onClick={onDownloadTpl}>下载模板</Button>
                </YhAuth>
            </div>

            <Table
                columns={columns}
                dataSource={customerList}
                rowKey={record => record.id}
                bordered
                pagination={true}
                pagination={{
                    hideOnSinglePage: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: pageInfo.total,
                    current: pageInfo.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedCustomer && selectedCustomer.key === record.key) {
                                setSelectedCustomer(null);
                                setSelectedCustomerRowKeys([]);
                            } else {
                                setSelectedCustomer(record);
                                setSelectedCustomerRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedCustomer(selectedRows[0]);
                        setSelectedCustomerRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled User',
                        name: record.name,
                    }),
                    selectedRowKeys: selectedCustomerRowKeys
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    );
}